<template>
   <div class='mymenu-detail batt-swap-page'>
      <div class="menu-content">
         <bs-card-menu :options='myMenuInfo' status></bs-card-menu>
         <div class="menu-open-time">
            <!-- 开通时间 -->
            <p v-if="myMenuInfo.openTime">{{$t('bstext.bs49')}}:{{myMenuInfo.openTime | formatDate('yyyy.MM.dd hh:mm:ss')}}</p>
            <!-- 激活时间 -->
            <p v-if="myMenuInfo.activeTime">{{$t('bstext.bs50')}}:{{myMenuInfo.activeTime | formatDate('yyyy.MM.dd hh:mm:ss')}}</p>
            <!-- 关闭时间 -->
            <p v-if="myMenuInfo.closeTime">{{$t('bstext.bs51')}}:{{myMenuInfo.closeTime | formatDate('yyyy.MM.dd hh:mm:ss')}}</p>
            <!-- 变更时间 -->
            <p v-if="myMenuInfo.updateTime">{{$t('bstext.bs52')}}:{{myMenuInfo.updateTime | formatDate('yyyy.MM.dd hh:mm:ss')}}</p>
         </div>
      </div>
      <div class="btn-box">
         <bs-button class="w100" :class="{'mb':myMenuInfo.showCloseBtn}" v-if="myMenuInfo.showChangeBtn" @click="editService">{{$t('bstext.bs7')}}</bs-button>
         <!-- 取消套餐 -->
         <bs-button class="w100" type="black-gray" v-if="myMenuInfo.showCloseBtn" @click="closeService">{{$t('bstext.bs53')}}</bs-button>
      </div>
      <bs-dialog :visible.sync="visible" theme="normal" width="calc(100vw - 32px)">
         <!-- 您的原套餐已使用超过3个月，如转换需要缴纳3000台币的运营费用，费用将统计至本月账单，请确认后转换。 -->
          <div style="word-wrap:break-word">{{$t('bstext.bs54')}}</div>
          <template v-slot:footer>
             <div class="flex-center-center" style="padding-bottom:24px">
                <!--我再想想 -->
               <bs-button style="width: 145px" type="light-gray" size="small" round @click="think">{{$t('bstext.bs55')}}</bs-button>
               <!-- 我已知晓，确认变更 -->
               <bs-button style="width: 145px;margin-left:5vw" size="small" @click="confirm">{{$t('bstext.bs56')}}</bs-button>
             </div>
          </template>
      </bs-dialog>
      <bs-dialog :visible.sync="closeVisible">
         <!-- 是否确认取消 -->
          <div>{{$t('bstext.bs57')}}</div>
          <template v-slot:footer>
             <div class="flex bs-hairline-top">
               <!-- 取消 -->
               <bs-button noround style="width: 50%" type="gray" size="small" @click="cancel">{{$t('bstext.bs58')}}</bs-button>
               <!-- 确认 -->
               <bs-button noround class="bs-hairline-left" style="width: 50%" type="gray" size="small" @click="confirmClose">{{$t('bstext.bs59')}}</bs-button>
             </div>
          </template>
      </bs-dialog>
   </div>
</template>

<script>
const status ={
   unactive:'1',
   use:'2',
   change:'3',
   close:'4',
}
const statusClass={
   '1':'status-red',
   '2':'status-blue',
   '3':'status-gray',
   '4':'status-gray',
}
import utils from '@/utils/index.js'
import entrance from '@/mixin/entrance'
export default {
   data () {
      return {
         lan:this.$route.query.lan,
         visible:false,
         closeVisible:false,
         status:status,
         myMenuInfo:{},
         id:parseInt(this.$route.params.id),
         cycles:[],//付费周期
         menus:[],//套餐状态
      }
   },
   mixins:[entrance],
   mounted() {
      this.cycles=this.$t('bsstatus.cycles')
      this.menus=this.$t('bsstatus.menus')
      // 我的套餐
      document.title = this.$t('bstext.bs60')
   },
   watch:{
      token:function(newToken,oldToken){
         if(newToken){
            this.getServiceOpeninfo()
         }
      }
   },
   methods: {
      // 更改套餐 istoll 套餐是否超过3个月
   editService(){
      // if(this.myMenuInfo.isToll){
      //    this.visible=true
      // }else{
      //    this.$router.push(`/bs/battswap/selmenulist/${this.myMenuInfo.serviceId}`)
      // }
      this.$router.push(`/bs/battswap/selmenulist/${this.myMenuInfo.serviceId}`)
   },
   // 取消套餐
   closeService(){
      this.closeVisible=true
   },
   cancel(){
      this.closeVisible=false      
   },
   confirmClose(){
      this.$appApi.nativeLoading(true,'',0)      
      let req ={
         serviceId:this.myMenuInfo.serviceId,
      }
      this.$server.closeService(req).then(res=>{
         this.closeVisible=false
         // 你已取消换电套餐【this.myMenuInfo.name】
         let msg = this.$t('bstext.bs61',{msg:this.myMenuInfo.name})
         this.$BsMessage({message:msg})
         this.getServiceOpeninfo()
      }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
      })      
   },
   getServiceOpeninfo(){
      this.$appApi.nativeLoading(true,'',0)
      let req ={
         id:this.id
      }
      this.$server.getServiceOpeninfo(req).then(res=>{
         let info =res.data
         info.theme="yellow"
         info.cycle = utils.formatStatus(info.cycle,this.cycles)
         info.price = utils.formatPrice(info.price)
         info.statusText=utils.formatStatus(info.status,this.menus)
         info.statusClass=statusClass[info.status]
         if(info.canChange){
            info.showChangeBtn=true
         }else{
            info.showChangeBtn=false
         }
         info.showCloseBtn=info.status==this.status.unactive?true:false
         this.myMenuInfo=info
      }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
   },
   // 我再想想
   think(){
      this.visible=false
   },
   // 我已知晓
   confirm(){
      this.$router.push(`/bs/battswap/selmenulist/${this.myMenuInfo.serviceId}`)
   }
   }
}
</script>

<style lang='less' scoped>
.mymenu-detail{
   box-sizing: border-box;
   min-height: 100vh;
   padding: 16px 20px;
   background: #101016;
   .menu-content{
      background: #1B1B21;
      border-radius: 8px;
      .menu-open-time{
         padding: 20px 16px 8px;
         p{
            margin-bottom: 8px;
            font-size: 14px;
            color: #8C92A0;
            line-height: 20px;
         }
      }
   }
   .btn-box {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 40px 40px;
    width: 100%;
    .mb {
      margin-bottom: 16px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/mymenu/mymenudetail.vue